<template>
  <nav class="bg-gray-700 font-display">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <img
              class="h-8 w-8"
              src="@/assets/img/favicon.png"
              alt="Estico Logo"
            />
          </div>
          <div class="hidden md:block">
            <div class="ml-10 flex items-baseline">
              <router-link
                v-for="items in menu"
                :key="items.route.name"
                :to="{ name: items.route.name }"
                class="ml-4 px-3 py-5 text-sm font-medium text-gray-100 hover:text-gray-300 focus:outline-none focus:text-gray-300"
              >
                {{ items.route.title }}
              </router-link>
            </div>
          </div>
        </div>
        <div class="hidden md:block">
          <div class="ml-4 flex items-center md:ml-6">
            <button
              class="text-2xl px-2 border-2 border-transparent text-gray-400 rounded-full hover:text-gray-500 focus:outline-none focus:text-white focus:bg-gray-600"
              aria-label="Notifications"
            >
              <font-awesome-icon icon="bell" />
            </button>

            <!-- Profile dropdown -->
            <div class="ml-3 relative">
              <Dropdown>
                <template #trigger>
                  <div class="text-center">
                    <button
                      class="text-sm font-bold text-white px-4 py-2 bg-indigo-700 rounded-lg border border-indigo-600 flex text-sm border-2 border-transparent focus:outline-none focus:border-gray-600 transition duration-150 ease-in-out"
                    >
                      Minha Conta
                    </button>
                  </div>
                </template>
                <template #content>
                  <div class="block px-4 py-2 text-xs text-gray-400">
                    Gerenciar Conta
                  </div>
                  <div class="block px-4 py-2 text-xs text-gray-700">
                    <router-link
                      class="text-sm"
                      active-class=""
                      :to="{ name: 'account.index' }"
                    >
                      Minha Conta
                    </router-link>
                  </div>
                  <div class="block px-4 py-2 text-xs text-gray-700">
                    <router-link
                      class="text-sm"
                      active-class=""
                      :to="{ name: 'subscription.my' }"
                    >
                      Assinatura
                    </router-link>
                  </div>
                  <div class="block px-4 py-2 text-xs text-gray-700">
                    <a href="" @click.prevent="doLogout">Sair</a>
                  </div>
                </template>
              </Dropdown>
            </div>
          </div>
        </div>
        <div class="-mr-2 flex md:hidden">
          <!-- Mobile menu button -->
          <button
            @click="menuExpand"
            class="inline-flex items-center justify-center p-2 rounded-md text-gray-600 hover:text-white hover:bg-gray-700 focus:outline-none focus:bg-gray-700 focus:text-white"
          >
            <!-- Menu open: "hidden", Menu closed: "block" -->
            <svg
              class="block h-6 w-6"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                :class="{ block: !open, hidden: open }"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
              <path
                :class="{ block: open, hidden: !open }"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
            <!-- Menu open: "block", Menu closed: "hidden" -->
            <svg
              class="hidden h-6 w-6"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!--
      Mobile menu, toggle classes based on menu state.

      Open: "block", closed: "hidden"
    -->
    <div class="md:hidden" :class="{ block: open, hidden: !open }">
      <div class="px-2 pt-2 pb-3 sm:px-3 border-t border-gray-600">
        <router-link
          v-for="items in menu"
          :key="items.route.name"
          :to="{ name: items.route.name }"
          class="mt-1 block px-3 py-2 text-base font-medium text-gray-100 hover:text-gray-500 focus:outline-none"
        >
          {{ items.route.title }}
        </router-link>
      </div>
      <div class="pt-4 pb-3 border-t border-gray-600 bg-gray-800">
        <router-link
          class="mt-1 block px-3 py-2 text-base font-medium text-gray-100 hover:text-gray-500 focus:outline-none"
          active-class=""
          :to="{ name: 'account.index' }"
        >
          Minha Conta
        </router-link>
        <router-link
          class="mt-1 block px-3 py-2 text-base font-medium text-gray-100 hover:text-gray-500 focus:outline-none"
          active-class=""
          :to="{ name: 'subscription.my' }"
        >
          Assinatura
        </router-link>
        <a
          class="mt-1 block px-3 py-2 text-base font-medium text-gray-100 hover:text-gray-500 focus:outline-none"
          href=""
          @click.prevent="doLogout"
          >Sair</a
        >
      </div>
    </div>
  </nav>
</template>

<script>
import Dropdown from '@/components/Dropdown'
export default {
  watch: {
    $route(to, from) {
      this.open = false
    }
  },
  components: {
    Dropdown
  },
  data() {
    return {
      open: false,
      menu: [
        {
          icon: 'home-alt',
          route: {
            title: 'Dashboard',
            name: 'dashboard'
          }
        },

        {
          icon: 'link-alt',
          route: {
            title: 'Meus Produtos',
            name: 'store.product.index'
          }
        },
        {
          icon: 'link-alt',
          route: {
            title: 'Categorias',
            name: 'store.category.index'
          }
        },

        {
          icon: 'receipt',
          route: {
            title: 'Pedidos',
            name: 'orders.index'
          }
        },

        {
          icon: 'receipt',
          route: {
            title: 'Clientes',
            name: 'customers.index'
          }
        },
        {
          icon: 'receipt',
          route: {
            title: 'Configurações',
            name: 'settings.index'
          }
        }
      ]
    }
  },
  methods: {
    doLogout() {
      this.$store.dispatch('LOGOUT_USER').then((response) => {
        this.$router.push({ name: 'login' })
        this.$toasted.success('Deslogado com sucesso!', {
          position: 'top-center',
          duration: 5000,
          icon: 'check'
        })
      })
    },
    menuExpand() {
      this.open = !this.open
    }
  }
}
</script>

<style>
</style>
